/* eslint-env browser, es6 */
/**
 * Functions to get and set nicknames that are persistent for a given duel across page refreshes.
 *
 * This allows the current user's nickname to be highlighted on the duel results page even after
 * they refresh the page.
 *
 * It also allows the nickname input to be pre-populated with the user's last saved nickname.
 */

export function getPersistentNicknameForDuel(duelId: string): string {
  return window.localStorage.getItem(nicknameKey(duelId)) ?? "";
}

const DEFAULT_NICKNAME_KEY = "duel-default-nickname";

export function getDefaultPersistentNickname(): string {
  return window.localStorage.getItem(DEFAULT_NICKNAME_KEY) ?? "";
}

export function setPersistentNicknameForDuel(
  duelId: string,
  nickname: string
): void {
  // Always set the default nickname to the latest saved nickname.
  window.localStorage.setItem(DEFAULT_NICKNAME_KEY, nickname);
  window.localStorage.setItem(nicknameKey(duelId), nickname);
}

function nicknameKey(duelId: string): string {
  return `duel-nickname-${duelId}`;
}
